import styled, { useTheme } from 'styled-components';
import useFetch from '../../../api/useFetch';
import {
  bomListGetApi,
  bomPostApi,
  BomRequestType,
  itemAbbrListGetApi,
  itemAbbrPostApi,
  ItemAbbrType,
  ItemBomResponseEssType,
  ItemBomResponseType,
  ItemBomType,
  itemListGetApi,
  parcelItemListAllGetApi,
  parcelItemListGetApi,
  parcelItemPostApi,
  ParcelItemResponseType,
  parcelTraderListAllGetApi,
  parcelTraderPostApi,
  ParcelTraderResponseType,
  ProductItem,
  traderAbbrListGetApi,
  traderAbbrPostApi,
  TraderAbbrType,
  traderListGetApi,
  TraderType,
} from '../../../api/apiConfig';
import { useEffect, useState } from 'react';
import { BomEditModal } from '../../../component/common/modal/ModalComponents/BomEditModal';
import { ParcelItemEditModal } from '../../../component/common/modal/ModalComponents/ParcelItemEditModal';
import { ParcelTraderEditModal } from '../../../component/common/modal/ModalComponents/ParcelTraderEditModal';
import { InputUnderline } from '../../../component/input/InputUnderline';
import { IoSaveOutline } from 'react-icons/io5';
import { SearchBar } from '../../../component/common/SearchBar';
import { useHeaderButtons } from '../../../component/header/HeaderButtonProvider';
import SquareButton from '../../../component/button/SquareButton';

export const ItemAbbreviationPage = () => {
  const [itemAbbrs, setItemAbbrs] = useState<ItemAbbrType[]>([]);

  const { setButtons } = useHeaderButtons();

  const theme = useTheme();

  const [searchTerm, setSearchTerm] = useState<string>('');

  const { fetch: fetchItemAbbrListGetApi } = useFetch({
    fetchFunction: itemAbbrListGetApi,
    onSuccess: (data: ItemAbbrType[]) => setItemAbbrs(data),
  });

  const { fetch: fetchItemAbbrPostApi } = useFetch({
    fetchFunction: itemAbbrPostApi,
    onSuccess: (data: ItemAbbrType[]) =>
      setItemAbbrs((prev) =>
        prev.map((abbr) => {
          const matchedData =
            data.find((newAbbr) => newAbbr.PROD_CD === abbr.PROD_CD) || null;

          if (matchedData == null) {
            return abbr;
          } else {
            return {
              ...abbr,
              abbr: matchedData.abbr,
            };
          }
        })
      ),
  });

  useEffect(() => {
    fetchItemAbbrListGetApi();
  }, []);

  useEffect(() => {
    //헤더에 버튼 추가
    setButtons(
      <>
        <SquareButton
          text='일괄 저장'
          colorType='ACTIVE'
          onClick={() => saveHandler()}
        />
      </>
    );
    // 페이지가 바뀌면 버튼 초기화
    return () => setButtons(null);
  }, [setButtons]);

  function saveHandler() {
    const changedDivs = document.querySelectorAll('.updated-true');

    const dtoList: ItemAbbrType[] = [];

    changedDivs.forEach((div) => {
      // div의 자식 요소인 input 찾기
      const input = div.querySelector('input');

      if (input) {
        // input의 id와 value를 가져오기
        const inputId = input.getAttribute('id');
        const inputValue = input.value;

        if (inputId == null) return;

        const dto: ItemAbbrType = {
          PROD_CD: inputId,
          abbr: inputValue,
          PROD_DES: '',
        };
        dtoList.push(dto);
      }
    });
    fetchItemAbbrPostApi(dtoList);
  }

  const InputArea = ({ item }: { item: ItemAbbrType }) => {
    const [inputText, setInputText] = useState<string>(item.abbr || '');

    const [isUpdated, setIsUpdated] = useState<boolean>(false);

    useEffect(() => {
      if (
        (item.abbr == null || item.abbr?.trim() === '') &&
        inputText.trim() !== ''
      ) {
        setIsUpdated(true);
      } else if (
        item.abbr != null &&
        item.abbr?.trim() !== '' &&
        item.abbr !== inputText
      ) {
        setIsUpdated(true);
      } else {
        setIsUpdated(false);
      }
    }, [inputText]);

    return (
      <div
        className={`label flex-center updated-${isUpdated}`}
        style={{ position: 'relative' }}
      >
        <input
          value={inputText}
          id={item.PROD_CD}
          onChange={(e) => setInputText(e.target.value)}
          placeholder='등록된 이름이 없습니다'
          style={{
            width: '60%',
            border: 'none',
            outline: 'none',
            fontWeight: 500,
            fontSize: '15px',
            backgroundColor: 'transparent',
            textAlign: 'center',
            // color: isUpdated ? 'black' : 'gray',
          }}
          onFocus={(e) => (e.target.placeholder = '')}
          onBlur={(e) => (e.target.placeholder = '등록된 이름이 없습니다')}
        />
      </div>
    );
  };

  return (
    <Container>
      <h2 style={{ marginTop: '0px' }}>품목 약칭 목록</h2>
      <SearchBar onSearch={setSearchTerm} width='400px' margin='0 0 10px 0' />
      <RowContainer>
        <HeaderRow>
          <h4 className='prod-des flex-center'>품목명</h4>
          <h4 className='label flex-center'>페이지에서 사용될 이름</h4>
        </HeaderRow>
        {itemAbbrs.length > 0 &&
          itemAbbrs
            .filter((item) => {
              if (searchTerm.trim() === '') {
                return true;
              } else {
                return (
                  item.PROD_DES.includes(searchTerm) ||
                  item.abbr?.includes(searchTerm)
                );
              }
            })
            .map((item, index) => {
              return (
                <Row odd={index % 2 === 1}>
                  <h5 className='prod-des flex-center'>{item.PROD_DES}</h5>
                  <InputArea item={item} />
                </Row>
              );
            })}
        <Row></Row>
      </RowContainer>
    </Container>
  );
};

const Container = styled.div``;

const RowContainer = styled.div`
  /* background-color: white; */
`;

const Row = styled.div<{ odd?: boolean }>`
  display: flex;
  width: 100%;
  height: 32px;
  flex-direction: row;
  align-items: center;

  background-color: ${({ odd, theme }) =>
    odd ? theme.colors.white_odd : theme.colors.white};

  .prod-des {
    flex: 1 0 20%;
    &:hover {
      text-decoration: underline;
      font-weight: 700;
      cursor: pointer;
    }
  }
  .label {
    flex: 1 0 20%;
  }
`;

const HeaderRow = styled(Row)`
  height: 30px;
  border-bottom: 3px solid ${({ theme }) => theme.colors.charcoal};
  box-sizing: border-box;
  .has-bom {
    &:hover {
      text-decoration: none;
      cursor: auto;
    }
  }
`;
